const state = {
    allowedToStream: false,
    subscription: null,
    stripeCustomerReference: null,
    justUpgradedToAnnualSubscription: false,
    downloadError: null,
    lastProductLineFileDownloaded: null,
    discount: null,
};

const getters = {
    subscription: state => state.subscription,
    stripeCustomerReference: state => state.stripeCustomerReference,
    membershipName: state => {
        if (state.subscription && state.subscription.membership) {
            return state.subscription.membership.name;
        }

        return null;
    },
    allowedToStream: state => state.allowedToStream,
    hasLegacyPaypalSubscription: state => {
        return state.subscription && state.subscription.provider.toLowerCase() === 'paypal legacy';
    },
    paidFor: state => state.allowedToStream,
    active: state => state.subscription && state.subscription.status === 'active',
    expiring: state => state.subscription && state.subscription.status === 'expiring',
    paused: state => state.subscription && state.subscription.status === 'paused',
    cancelled: state => state.subscription && state.subscription.status === 'cancelled',
    unpaid: state => state.subscription && state.subscription.status === 'unpaid',
    failed: state => state.subscription && state.subscription.failed && state.subscription.status === 'inactive',
    pending: state => state.subscription && state.subscription.pending,

    hasActiveGiftSubscription: state => {
        return state.subscription && state.subscription.status === 'active' && state.subscription.membership.slug === "licklibrary-12-month-gifted";
    },

    downloadError: state => state.downloadError,
    lastProductLineFileDownloaded: state => state.lastProductLineFileDownloaded,
    stripe: state => state.subscription && state.subscription.provider && state.subscription.provider.toLowerCase() === 'stripe',
    justUpgradedToAnnualSubscription: state => state.justUpgradedToAnnualSubscription,
    discount: state => state.discount,
    isUltimate: state => state.subscription?.membership?.slug?.includes('ultimate'),
    usesPaymentGateway: state => ['stripe', 'paypal'].includes(state.subscription?.provider?.toLowerCase()),
};

const mutations = {
    updateSubscription: (state, data) => {
        state.subscription = data.subscription;
        state.stripeCustomerReference = data.stripeCustomerReference;
        state.allowedToStream = data.allowedToStream;
    },
    justUpgradedToAnnualSubscription: (state, value) => state.justUpgradedToAnnualSubscription = value,
    downloadError: (state, value) => state.downloadError = value,
    lastProductLineFileDownloaded: (state, value) => state.lastProductLineFileDownloaded = value,
    discount: (state, value) => state.discount = value,
};

const actions = {
    downloadProductLineFile({commit}, {productLineFileId, ignoreLimitAlmostReachedMessage, openInNewTab}) {
        const url = `/download-product-line-file/${productLineFileId}`;
        const data = {ignoreLimitAlmostReachedMessage: !!ignoreLimitAlmostReachedMessage};

        commit('lastProductLineFileDownloaded', productLineFileId);

        return axios.post(url, data).then(response => {
            if (openInNewTab) {
                window.open(response.data.url, '_blank').focus();
            } else {
                window.location = response.data.url;
            }
        }).catch(error => {
            if (error?.response?.data?.message) {
                if (error.response.data.message === 'not-subscribed') {
                    commit('modal/toggleModal', true, {root: true});
                } else if (['monthly-limit-reached', 'monthly-limit-nearly-reached'].includes(error.response.data.message)) {
                    commit('downloadError', error.response.data.message);
                }
            }
        });
    },
};

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
